import { CheckNotes, InspectionCase } from '../inspection-cases';
import { AutoDialer } from './auto-dialer.dto';
import { BeamsAndPartitions } from './beams-and-partitions.dto';
import { CellularAutoDialer } from './cellular-auto-dialer.dto';
import { ComponentsActivation } from './components-activation.dto';
import { DetectorsInstallation } from './detectors-installation.dto';
import { DialRiskLevel } from './dial-risk-level.dto';
import { DiscoveryHub } from './discovery-hub.dto';
import { FireAlarmSystemComponents } from './fire-alarm-components.dto';
import { FireAlarmSystemMain } from './fire-alarm-system-main.dto';
import { FirefightersPhone } from './firefighters-phone.dto';
import { PaSystem } from './pa-system.dto';
import { PowerPanel } from './power-panel.dto';
import { SirensAndMarkingLamps } from './sirens-and-marking-lamps.dto';
import { SpecialInstallations } from './special-installations.dto';
import { StandaloneDetectors } from './standalone-detectors.dto';

export class FireAlarmSystemDesignDto extends InspectionCase {
  main?: FireAlarmSystemMain;
  fireAlarmSystemComponents?: FireAlarmSystemComponents;
  dialRiskLevelOne?: DialRiskLevel;
  dialRiskLevelTwo?: DialRiskLevel;
  dialRiskLevelTwoAccommodation?: DialRiskLevel;
  autoDialer?: AutoDialer;
  cellularAutoDialer?: CellularAutoDialer;
  discoveryHub?: DiscoveryHub;
  detectorsInstallation?: DetectorsInstallation;
  beamsAndPartitions?: BeamsAndPartitions;
  powerPanel?: PowerPanel;
  sirensAndMarkingLamps?: SirensAndMarkingLamps;
  paSystem?: PaSystem;
  specialInstallations?: SpecialInstallations;
  firefightersPhone?: FirefightersPhone;
  componentsActivation?: ComponentsActivation;
  standaloneDetectors?: StandaloneDetectors;
}

export class FireAlarmSystemDesign extends FireAlarmSystemDesignDto {
  constructor(
    data: FireAlarmSystemDesignDto = {
      title: 'תכנון / התקנה',
      isApplicable: true
    }
  ) {
    super(data);
    this.main = new FireAlarmSystemMain(data.main);
    this.fireAlarmSystemComponents = new FireAlarmSystemComponents(
      data.fireAlarmSystemComponents
    );
    this.dialRiskLevelOne = new DialRiskLevel({
      ...data.dialRiskLevelOne,
      title:
        'חייגן בהתאם לדרגת סיכון 1: החייגן האוטומטי מחייג למי שהוחלט ע"י מחזיק הנכס או מישהו מטעמו. (לא מאושר חיוג לכיבוי אש)'
    });
    this.dialRiskLevelTwo = new DialRiskLevel({
      ...data.dialRiskLevelTwo,
      title:
        'חייגן בהתאם לדרגת סיכון 2: (החייגן האוטומטי מחייג למי שהוחלט ע"י מחזיק הנכס או מישהו מטעמו)'
    });
    this.dialRiskLevelTwoAccommodation = new DialRiskLevel({
      ...data.dialRiskLevelTwoAccommodation,
      title:
        'חייגן בדרגת סיכון 2 במקומות עם לינה: (בתי חולים , בתי אבות , בתי מלון , בתי החלמה , מוסדות גריאטריים , בתי סוהר , מוסדות סגורים , בתי הארחה  ופנימיות , בכל הפעלת גלאי  יופעל החייגן ויחייג לכיבוי אש ולבעל הנכס)'
    });
    this.autoDialer = new AutoDialer(data.autoDialer);
    this.cellularAutoDialer = new CellularAutoDialer(data.cellularAutoDialer);
    this.discoveryHub = new DiscoveryHub(data.discoveryHub);
    this.detectorsInstallation = new DetectorsInstallation(
      data.detectorsInstallation
    );
    this.beamsAndPartitions = new BeamsAndPartitions(data.beamsAndPartitions);
    this.powerPanel = new PowerPanel(data.powerPanel);
    this.sirensAndMarkingLamps = new SirensAndMarkingLamps(
      data.sirensAndMarkingLamps
    );
    this.paSystem = new PaSystem(data.paSystem);
    this.specialInstallations = new SpecialInstallations(
      data.specialInstallations
    );
    this.firefightersPhone = new FirefightersPhone(data.firefightersPhone);
    this.componentsActivation = new ComponentsActivation(
      data.componentsActivation
    );
    this.standaloneDetectors = new StandaloneDetectors(
      data.standaloneDetectors
    );
  }

  setInspectionStatus(): void {
    this.main.setInspectionStatus();
    this.dialRiskLevelOne.setInspectionStatus();
    this.dialRiskLevelTwo.setInspectionStatus();
    this.dialRiskLevelTwoAccommodation.setInspectionStatus();
    this.autoDialer.setInspectionStatus();
    this.cellularAutoDialer.setInspectionStatus();
    this.discoveryHub.setInspectionStatus();
    this.detectorsInstallation.setInspectionStatus();
    this.beamsAndPartitions.setInspectionStatus();
    this.powerPanel.setInspectionStatus();
    this.sirensAndMarkingLamps.setInspectionStatus();
    this.paSystem.setInspectionStatus();
    this.specialInstallations.setInspectionStatus();
    this.firefightersPhone.setInspectionStatus();
    this.componentsActivation.setInspectionStatus();
    this.standaloneDetectors.setInspectionStatus();
    this.isPassed =
      this.main.isPassed &&
      this.dialRiskLevelOne.isPassed &&
      this.dialRiskLevelTwo.isPassed &&
      this.dialRiskLevelTwoAccommodation.isPassed &&
      this.autoDialer.isPassed &&
      this.cellularAutoDialer.isPassed &&
      this.discoveryHub.isPassed &&
      this.detectorsInstallation.isPassed &&
      this.beamsAndPartitions.isPassed &&
      this.powerPanel.isPassed &&
      this.sirensAndMarkingLamps.isPassed &&
      this.paSystem.isPassed &&
      this.specialInstallations.isPassed &&
      this.firefightersPhone.isPassed &&
      this.componentsActivation.isPassed &&
      this.standaloneDetectors.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.main.getNotes(),
      ...this.dialRiskLevelOne.getNotes(),
      ...this.dialRiskLevelTwo.getNotes(),
      ...this.dialRiskLevelTwoAccommodation.getNotes(),
      ...this.autoDialer.getNotes(),
      ...this.cellularAutoDialer.getNotes(),
      ...this.discoveryHub.getNotes(),
      ...this.detectorsInstallation.getNotes(),
      ...this.beamsAndPartitions.getNotes(),
      ...this.powerPanel.getNotes(),
      ...this.sirensAndMarkingLamps.getNotes(),
      ...this.paSystem.getNotes(),
      ...this.specialInstallations.getNotes(),
      ...this.firefightersPhone.getNotes(),
      ...this.componentsActivation.getNotes(),
      ...this.standaloneDetectors.getNotes()
    ];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.main.setAsApplicable();
    this.dialRiskLevelOne.setAsApplicable();
    this.dialRiskLevelTwo.setAsApplicable();
    this.dialRiskLevelTwoAccommodation.setAsApplicable();
    this.autoDialer.setAsApplicable();
    this.cellularAutoDialer.setAsApplicable();
    this.discoveryHub.setAsApplicable();
    this.detectorsInstallation.setAsApplicable();
    this.beamsAndPartitions.setAsApplicable();
    this.powerPanel.setAsApplicable();
    this.sirensAndMarkingLamps.setAsApplicable();
    this.paSystem.setAsApplicable();
    this.specialInstallations.setAsApplicable();
    this.firefightersPhone.setAsApplicable();
    this.componentsActivation.setAsApplicable();
    this.standaloneDetectors.setAsApplicable();
  }
}
